/// <amd-module name="TFS/FeatureManagement/FeaturePanel" />
export { IFeatureManagementPanelComponentProps, IFeatureManagementScope } from "./Components/FeaturePanel/FeaturePanel.Props";
export * from "./Components/FeaturePanel/FeaturePanel";
